module.exports = __webpack_public_path__ + "static/media/Helvetica-Oblique.5e9d01a5.ttf";